"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownV1 = DropdownV1;
exports.default = Dropdown;
var _material = require("@mui/material");
var _SelectT = _interopRequireDefault(require("./Select/SelectT"));
var _Autocomplete = _interopRequireDefault(require("./Autocomplete/Autocomplete"));
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
const useStyles = (0, _styles.makeStyles)(() => ({
  formControl: {
    width: '100%'
  }
}));
function DropdownV1(_ref) {
  let {
    id,
    label,
    values,
    onChange,
    selected,
    disabled
  } = _ref;
  const onChangeH = (event, _child) => {
    onChange(event.target.value);
  };
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    variant: "outlined",
    className: classes.formControl,
    size: "small",
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "".concat(id, "-outlined-label")
  }, label), /*#__PURE__*/_react.default.createElement(_material.Select, {
    labelId: "".concat(id, "-outlined-label"),
    id: id,
    label: label,
    onChange: onChangeH,
    value: selected
  }, values === null || values === void 0 ? void 0 : values.map(_ref2 => {
    let {
      label: inLabel,
      value
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      id: value,
      key: value,
      value: value
    }, inLabel);
  })));
}
/**
 * This is a simple dropdwn that takes in a tuple { label, value }
 * for list of options.
 * The label is used for display, the value is passed back in onChange, and used to set selectedValue.
 *
 * Example:
 * <Dropdown
 *   options=[{ label: 'label', value: 'value'}, { label: 'label1': value: 'value1'} ]
 *   onChange={(value: string) => setSomeValue(value)}
 *   selectedValue={'value1'}
 * />
 */
function Dropdown(props) {
  const {
    selectedValue,
    onChange,
    options,
    autocomplete,
    ...remainingProps
  } = props;
  const selectedItem = options === null || options === void 0 ? void 0 : options.find(option => option.value === selectedValue);
  const renderOption = option => {
    const styles = {
      fontWeight: option.fontWeight || 'normal',
      fontStyle: option.fontStyle || 'normal'
    };
    return /*#__PURE__*/_react.default.createElement("span", {
      style: styles
    }, option.label);
  };
  if (autocomplete) {
    return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, Object.assign({}, remainingProps, {
      options: options !== null && options !== void 0 ? options : [],
      selected: selectedItem || '',
      isEqual: (A, B) => A.value === B.value,
      onChange: option => onChange(option.value)
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_SelectT.default, Object.assign({}, remainingProps, {
    options: options,
    selectedValue: selectedItem,
    isEqual: (A, B) => A.value === B.value,
    renderOption: renderOption,
    toT: str => ({
      label: str,
      value: str
    }),
    displayLabel: option => (option === null || option === void 0 ? void 0 : option.label) || '',
    onChange: option => onChange(option.value)
  }));
}